import React from "react";
import { t } from "../../i18n";

const API_URL = process.env.REACT_APP_API_URL || "https://b.supchats.com";

export default function DocsPage() {
  return (
    <div className="public-page">
      <div className="public-hero">
        <h1>{t("Documentation")}</h1>
        <p>
          {t(
            "Step-by-step guide to install and manage your Supchats AI chatbot."
          )}
        </p>
      </div>

      <div className="public-section">
        <h2>{t("1. Create your Agent")}</h2>
        <ol>
          <li>{t("Open Dashboard → Agents and click Add.")}</li>
          <li>
            {t(
              "Fill in: Name, Domain (your site), Welcome message, Contact details (optional)."
            )}
          </li>
          <li>{t("Save. You can edit anytime.")}</li>
        </ol>
      </div>

      <div className="public-section">
        <h2>{t("2. Provide Knowledge")}</h2>
        <ul>
          <li>{t("Describe your FAQ and key information directly in the fields.")}</li>
          <li>
            {t(
              "Add helpful links (docs, blog posts) — the bot can use them as reference."
            )}
          </li>
          <li>{t("Note: uploading documents is not available yet.")}</li>
        </ul>
      </div>

      <div className="public-section">
        <h2>{t("3. Install Widget (Production Embed)")}</h2>
        <p>
          {t("Paste before </body> on your website (replace placeholders with your values):")}
        </p>
        <pre className="public-code">
{`<script type="text/javascript">
var Supchats_API=Supchats_API||{}, Supchats_LoadStart=new Date();
(function(){
  var s1=document.createElement("script"), s0=document.getElementsByTagName("script")[0];
  s1.async=true;
  s1.src='${API_URL}/api/widget-loader/{agentId}?widget_id={widget_id}';
  s1.charset='UTF-8';
  s1.setAttribute('crossorigin','*');
  s0.parentNode.insertBefore(s1,s0);
})();
</script>`}
        </pre>
        <p style={{ marginTop: 12 }}>
          {t(
            "Optional: pass visitor metadata to improve customer service (owner notes, tags):"
          )}
        </p>
        <pre className="public-code">
{`<script>
  window.Supchats_API = window.Supchats_API || {};
  Supchats_API.visitorName = 'John Doe';
  Supchats_API.contact = 'john@example.com';
  Supchats_API.custom = { plan: 'pro', referral: 'ad-123' };
</script>`}
        </pre>
      </div>

      <div className="public-section">
        <h2>{t("4. Manage Conversations")}</h2>
        <ul>
          <li>
            <strong>{t("Inbox")}</strong>:{" "}
            {t("View active/archived chats, reply, archive, search.")}
          </li>
          <li>
            <strong>{t("Real-time")}</strong>:{" "}
            {t("Messages are delivered via WebSocket — no refresh needed.")}
          </li>
          <li>
            <strong>{t("Auto-archive")}</strong>:{" "}
            {t("Enable optional auto-archive after inactivity in agent settings.")}
          </li>
        </ul>
      </div>

      <div className="public-section">
        <h2>{t("5. API for Automation")}</h2>
        <p>
          {t(
            "Available for authorized users. Use header X-API-Key (get it in Dashboard → Developer)."
          )}
        </p>
        <pre className="public-code">
{`# List chats
curl -H "X-API-Key: YOUR_API_KEY" "${API_URL}/api/v1/chats?agent_id=123"

# Get chat with messages
curl -H "X-API-Key: YOUR_API_KEY" "${API_URL}/api/v1/chats/{chatId}?include_messages=true"

# Send message
curl -X POST -H "Content-Type: application/json" -H "X-API-Key: YOUR_API_KEY" \\
  -d '{"message":"Hello from API"}' "${API_URL}/api/v1/chats/{chatId}/messages"`}
        </pre>
        <p>{t('Interactive "Try it" lives in Dashboard → Developer.')}</p>
      </div>

      <div className="public-section">
        <h2>{t("Troubleshooting")}</h2>
        <ul>
          <li>
            {t(
              "Widget not showing: verify domain matches agent settings; place script before </body>."
            )}
          </li>
          <li>
            {t("No messages: check browser console for CORS, ensure WebSocket not blocked.")}
          </li>
        </ul>
      </div>
    </div>
  );
}

